import { useRef } from 'react'
import { TypographyCaps, TypographyParagraph } from '../typography'
import clsx from 'clsx'

// Styles to override browser autofill
const autofillStyles = {
	backgroundColor: 'transparent !important',
}

export default function InlineURLInputField({
	name,
	id,
	type,
	placeholder,
	displayURL,
	helper,
	jsxHelper,
	isValid,
	isError,
	isInactive = false,
	icon,
	additionalClasses = '',
	containerWidth = 'w-80',
	displayName = true,
	displayRequired = false,
	lines = 1,
	value = '',
	onChange = () => {},
}: {
	name: string
	id?: string
	type?: string
	placeholder?: string
	displayURL?: string
	helper?: string
	jsxHelper?: JSX.Element
	isValid?: boolean
	isError?: boolean
	isInactive?: boolean
	icon?: React.ReactNode
	additionalClasses?: string
	containerWidth?: string
	displayName?: boolean
	displayRequired?: boolean
	lines?: number
	value?: string
	onChange?: (e: any) => void
}) {
	const inputId = id ? id : name
	const ref = useRef(null)

	const handleClick = e => {
		if (ref.current) {
			if (ref.current.children && ref.current.children[1]) {
				ref.current.children[1].focus()
			}
		} else {
			document.getElementById(name)?.focus()
		}
		// document.getElementById('#Lore URL')?.focus()
	}
	return (
		<div className={containerWidth}>
			{displayName && (
				<label
					htmlFor={name}
					className="mb-1 block leading-[14px] text-grey400 dark:text-grey500"
				>
					<TypographyCaps size="small">{`${name}${displayRequired ? ' *' : ''}`}</TypographyCaps>
				</label>
			)}
			<div className="mt group relative">
				<div
					className={clsx(
						'flex w-full rounded-md border-0 px-4 py-1.5 font-abc text-paragraphMedium outline-0 ring-1 ring-inset',
						!isValid &&
							!isError &&
							'text-textPrimaryLight ring-textInactiveLight dark:text-textPrimaryDark dark:ring-textInactiveDark',
						// Inactive
						isInactive &&
							'cursor-not-allowed bg-uiSecondaryLight text-textPrimaryLight placeholder:text-textSecondaryLight dark:bg-black dark:text-textPrimaryDark dark:placeholder:text-textSecondaryDark',
						!isInactive &&
							'cursor-pointer bg-white text-grey400 placeholder:text-grey400 dark:bg-dark dark:text-grey600 dark:placeholder:text-grey600',
						// Validated
						!isInactive && isValid && 'ring-green',
						// hasError
						!isInactive && isError && 'ring-red',
						// Hover
						!isInactive &&
							'hover:ring-textSecondaryLight dark:hover:ring-textSecondaryDark',
						// Focus
						!isInactive &&
							'focus:text-textPrimaryLight focus:placeholder-textPrimaryLight focus:ring-textPrimaryLight dark:focus:text-textPrimaryDark dark:focus:placeholder-textPrimaryDark dark:focus:ring-textPrimaryDark',
						additionalClasses,
					)}
					ref={ref}
					onClick={handleClick}
				>
					{displayURL && (
						<span className="flex select-none items-center pl-1 text-textSecondaryLight dark:text-textSecondaryDark">
							{displayURL}
						</span>
					)}
					<input
						id={name}
						name={inputId}
						type="text"
						value={value}
						onChange={onChange}
						placeholder={placeholder || '...'}
						className={clsx(
							'block flex-1 border-0 bg-transparent py-1.5 pl-0 focus:ring-0',
							//  sm:text-sm/6',
							'text-textPrimaryLight placeholder:text-grey400 dark:text-textPrimaryDark dark:placeholder:text-grey600',
						)}
						style={autofillStyles}
					/>
					<div
						className={clsx(
							'pointer-events-none absolute inset-y-0 right-0 flex items-center pr-3',
							isValid &&
								'text-green group-focus:text-textPrimaryLight dark:group-focus:text-textPrimaryDark',
							isError &&
								'text-red group-focus:text-textPrimaryLight dark:group-focus:text-textPrimaryDark',
							isInactive && 'text-textInactiveLight dark:text-textInactiveDark',
						)}
					>
						{icon}
					</div>
				</div>
			</div>
			{jsxHelper && jsxHelper}
			{helper && (
				<TypographyParagraph
					size="xSmall"
					additionalClasses={clsx(
						'mt-2',
						isError && jsxHelper === undefined
							? 'text-red dark:text-red'
							: 'text-textSecondaryLight dark:text-textSecondaryDark',
					)}
				>
					{helper}
				</TypographyParagraph>
			)}
		</div>
	)
}
